<template>
    <section id="sc-banner">
		<div class="page-banner bg-light">
			<div class="container">
				<div class="banner-img float-start">
					<img src="/assets/images/blue.png">
				</div>
				<div class="banner-text float-start">
					<h2>{{title1}}</h2>
					<h2><strong>{{title}}</strong></h2>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'HeaDer',
    setup() {
		return {};
    },
}
</script>